import { isEmpty } from './common';

const NON_NUMERIC_REGEX = /[^(\d*)]/g;
const PERCENT_SIGN_WITH_SPACE = '% ';

// 0.5 -> 50
// 0.333... -> 33
export const convertDecimalToPercentage = (decimal = 0.0): number =>
    Math.round(decimal * 100);

// 50 -> 0.5
// 33 -> 0.33
export const convertPercentageToDecimal = (percentage = 0): number =>
    // Round to two decimal places
    Math.round((percentage / 100) * 100) / 100;

// Input display preprends percentage sign (for UI ease within an input text box)
export const formatPercentageForInputDisplay = (percentage = 0): string =>
    `${PERCENT_SIGN_WITH_SPACE}${percentage}`;

// Regular display appends percentage sign
export const formatPercentageForDisplay = (percentage = 0): string =>
    `${percentage}%`;

// 0.5 -> % 50
// 0.3333... -> % 33
export const convertDecimalToPercentageForInputDisplay = (
    decimal = 0.0,
): string =>
    formatPercentageForInputDisplay(convertDecimalToPercentage(decimal));

// 0.5 -> 50%
// 0.3333... -> 33%
export const convertDecimalToPercentageForDisplay = (decimal = 0.0): string =>
    formatPercentageForDisplay(convertDecimalToPercentage(decimal));

// % 50 -> 0.5
// % 33 -> 0.33
export const convertPercentageForInputDisplayToDecimal = (
    percentage: string,
): number => {
    const numericPercentage = parseInt(
        percentage.replace(NON_NUMERIC_REGEX, ''),
        10,
    );
    return convertPercentageToDecimal(numericPercentage);
};

export const formatPercentageOnInputChange = (
    previousValue: string,
    nextValue: string,
): string => {
    // Remove anything other than digits (whole numbers only allowed)
    const working = nextValue.replace(NON_NUMERIC_REGEX, '');

    if (parseInt(working, 10) > 100) {
        // Don't allow percentage over 100
        return previousValue;
    }

    if (isEmpty(working)) {
        return '';
    }

    return `${PERCENT_SIGN_WITH_SPACE}${working}`;
};
